import Api from "@/services/Api";

export default {
  getOptions() {
    return Api().get("options");
  },

  getOption(id) {
    return Api().get('options/' + id)
  },
  create(payload) {
    return Api().post('options', payload)
  },
  update(id, payload) {
    return Api().put('options/' + id, payload)
  },
  delete(id) {
    return Api().delete('options/' + id)
  },

  getOptionPacks() {
    return Api().get("options/packs/");
  },

  getOptionPack(id) {
    return Api().get('options/packs/' + id)
  },
  createOptionPack(payload) {
    return Api().post('options/packs/', payload)
  },
  updateOptionPack(id, payload) {
    return Api().put('options/packs/' + id, payload)
  },
  deleteOptionPack(id) {
    return Api().delete('options/packs/' + id)
  },
  deleteOptionPackOption(packId, optionId) {
    return Api().delete('options/packs/' + packId + "/" + optionId)
  },
  createOptionPackOption(packId, optionId) {
    return Api().post('options/packs/' + packId + "/" + optionId)
  },

  upload(formData) {
    return Api().post("options/upload", formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
};